import React from "react";
import { observer, inject } from "mobx-react";
import StartObhEnBs from "./start-obhenbs";

const StartContainer = ({ store }) => (
  <React.Fragment>
    <StartObhEnBs />
  </React.Fragment>
);

export default inject("store")(observer(StartContainer));
